module.exports = __webpack_public_path__ + "img/marker--invisible-stroke.cb4b79e.svg";